/**
 * API service for the CBR application.
 */

import axios, { AxiosInstance } from 'axios';
import type {
  ReserveSummary,
  Reserve,
  WalletAddressResponse,
  BalanceResponse,
  ApiResponse,
} from '@/types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

class ApiService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
      }
    );
  }

  async getReserves(): Promise<ApiResponse<ReserveSummary[]>> {
    const response = await this.client.get('/reserves');
    return response.data;
  }

  async getReserve(slug: string): Promise<ApiResponse<Reserve>> {
    const response = await this.client.get(`/reserves/${slug}`);
    return response.data;
  }

  async getNextAddress(slug: string): Promise<ApiResponse<WalletAddressResponse>> {
    const response = await this.client.post(`/reserves/${slug}/next-address`);
    return response.data;
  }

  async getReserveBalance(slug: string): Promise<ApiResponse<BalanceResponse>> {
    const response = await this.client.get(`/reserves/${slug}/balance`);
    return response.data;
  }
}

export const apiService = new ApiService();
export default apiService;
